import { Component, Inject, OnInit } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { APIOperableComponent } from '../../../../../shared/components/api-operable/api-operable.component';
import { UIActiveDialogService } from '../../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../../security/service/auth.service';
import { PartsSupplierPartsDialogColumnsModel } from '../../../model/part-supplier-parts-dialog-columns.model';
import { PartsService } from '../../../service/parts.service';

@Component({
  selector: 'app-parts-supplier-parts-dialog',
  templateUrl:
    './console/app-js/modules/parts/components/parts-supplier-parts/parts-supplier-parts-dialog/parts-supplier-parts-dialog.component.html'
})
export class PartsSupplierPartsDialogComponent extends APIOperableComponent
  implements OnInit {
  public supplierPartsColumnsModel = PartsSupplierPartsDialogColumnsModel;
  public supplierParts = [];
  public loading = false;
  public isValid = true;
  public errorListener: Subject<any> = new Subject();

  constructor(
    @Inject('supplierId') private supplierId: string,
    @Inject('partId') private partId: string,
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    public partsService: PartsService,
    private activeDialog: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    this.getSupplierPart(this.partId, this.supplierId);
  }

  private getSupplierPart(partId: string, supplierId: string) {
    this.progressRef.start();
    this.loading = true;
    this.partsService.getPartSupplierPart(partId, supplierId).subscribe(
      res => {
        this.partsService.getSupplier(res.supplierId).subscribe(
          (supplier: any) => {
            res.name = supplier.name;
            this.supplierParts.push(res);
            this.loading = false;
            this.progressRef.complete();
          },
          () => {
            this.loading = false;
            this.progressRef.complete();
          }
        );
      },
      () => {
        this.loading = false;
        this.progressRef.complete();
      }
    );
  }

  public onSave() {
    // set a timeout so the onCellClose function calls first to save the data
    setTimeout(() => {
      this.activeDialog.close(this.supplierParts[0]);
    }, 400);
  }

  public cancelCloseButton(): void {
    this.activeDialog.dismiss();
  }

  public onCellClose(event) {
    this.supplierParts[0].sku =
      event.dataItem.sku === '' ? null : event.dataItem.sku;
    this.supplierParts[0].cost =
      event.dataItem.cost === '' ? null : event.dataItem.cost;
  }

  public onValueChange(data) {
    if (!data.isValid) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
  }

  public customErrorHandling(data) {
    if (data.control.value.toString().indexOf('.') !== -1) {
      if (data.control.value.toString().split('.')[1].length > 2) {
        this.errorListener.next({ customError: true });
      } else {
        this.errorListener.next(null);
      }
    }
  }
}
